"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStorageCacheHook = void 0;
const react_hook_retention_cache_1 = require("@smart-hook/react-hook-retention-cache");
const media_1 = require("../media");
const promise_1 = require("utils/promise");
const createStorageCacheHook = (converter, { retentionTime } = {}) => {
    const cache = (0, react_hook_retention_cache_1.retentionCache)({
        generator: (path) => __awaiter(void 0, void 0, void 0, function* () {
            const blob = yield (0, media_1.getFile)(path);
            return blob && (yield converter(blob));
        }),
        cleanUp: (v) => { },
        retentionTime: retentionTime || 1000,
    });
    const usePromiseResolver = (0, promise_1.createPromiseResolverHook)();
    return (path) => {
        const promise = (0, react_hook_retention_cache_1.useCachedValue)(path, cache);
        const result = usePromiseResolver(promise);
        return result;
    };
};
exports.createStorageCacheHook = createStorageCacheHook;
